<template>
  <div class="container d-flex flex-column" v-on:keydown="keyDown" tabindex="0">
    <Logged-user />
    <div class="row loader" v-if="loading">
      <div class="col align-self-center text-center ">
        <square-loader />
      </div>
    </div>
    <div v-else>
      <div>
        <div class="row">
          <div class="board-area col-12 col-md-6 col-lg-8 col-xl-7">
            <div class="row mt-4 mb-4" v-if="gameEnded">
              <div class="col-12">
                <img src="/static/i_winners.svg" width="100%"/>
              </div>
            </div>
            <div class="row mt-4 mb-4" v-if="gameEnded">
              <div class="col-12">
                <FinalScores v-bind:scores="scores" v-bind:totalTop="totalTop"/>
              </div>
            </div>
            <div class="draw-area row mt-2" v-if="!openedLetterSelection && drawTop">
              <div class="col-10" v-if="gameStarted && !gameEnded">
                <GameDraw
                v-bind:draw="draw"
                v-bind:roundNumber="roundNumber"
                v-on:tile-moved="tileMoved"
                v-on:open-letter-selection="openLetterSelection"
                v-on:clear-board="clearBoard"
                v-on:shuffle-draw="shuffleDraw">
                </GameDraw>
              </div>
              <div class="col-10" v-if="!gameStarted">
                La partie va bientôt commencer.<br />Préparez-vous !
              </div>
              <div class="col-2 d-none d-md-block">
                  <img src="/static/swap-vertical.svg" class="icon" title="Changer la disposition"
                    v-on:click="drawTop = !drawTop"/>
              </div>
              <div class="col-2 d-block d-md-none text-end">
                <RoundTimer v-bind:endDate="endDateTime" v-if="!gameEnded"></RoundTimer>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-if="updating" class="updating">
                  <clip-loader />
                </div>
                <Board v-bind:board="board"
                v-on:tile-moved="tileMoved"
                v-bind:roundNumber="roundNumber"
                v-bind:squareClicked="squareClicked"
                v-bind:horizontal="horizontal"
                v-bind:premium="premium"
                v-on:open-letter-selection="openLetterSelection"
                v-on:click-square="clickSquare"
                v-if="!openedLetterSelection"
                ></Board>
              </div>
            </div>
            <div v-if="openedLetterSelection">
              <SelectLetter v-on:close-letter-selection="closeLetterSelection"></SelectLetter>
            </div>
            <div class="draw-area row mt-2" v-if="!openedLetterSelection && !drawTop">
              <div class="col-10" v-if="gameStarted && !gameEnded">
                <GameDraw
                v-bind:draw="draw"
                v-bind:roundNumber="roundNumber"
                v-on:tile-moved="tileMoved"
                v-on:open-letter-selection="openLetterSelection"
                v-on:clear-board="clearBoard"
                v-on:shuffle-draw="shuffleDraw">
                </GameDraw>
              </div>
              <div class="col-10" v-if="!gameStarted">
                La partie va bientôt commencer.<br />Préparez-vous !
              </div>
              <div class="col-2 d-none d-md-block">
                  <img src="/static/swap-vertical.svg" class="icon" title="Changer la disposition"
                    v-on:click="drawTop = !drawTop"/>
              </div>
              <div class="col-2 d-block d-md-none text-end">
                <RoundTimer v-bind:endDate="endDateTime" v-if="!gameEnded"></RoundTimer>
              </div>
            </div>
            <div class="row mt-2" v-if="gameStarted && !gameEnded">
              <div class="col-12">
                <GameTextInput
                  v-on:tile-moved="tileMoved"
                  v-on:clear-board="clearBoard"
                  v-on:shuffle-draw="shuffleDraw"
                  v-on:horizontal="setHorizontal"
                  v-bind:squareClicked="squareClicked"
                  v-bind:boardValid="boardValid"
                  v-bind:roundNumber="roundNumber"
                  v-bind:bestRoundPlayed="bestRoundPlayed"
                  ref="gameTextInput"
                ></GameTextInput>
              </div>
            </div>
            <div class="row mt-4 d-none d-md-flex" v-if="gameStarted && definition">
              <div class="col-12">
                <Definition
                v-bind:word="word"
                v-bind:definition="definition"/>
              </div>
            </div>
          </div>
          <div class="info-area col-12 col-md-6 col-lg-4 col-xl-5">
            <div class="row">
              <div class="col-6">Partie: {{game.gameName}}</div>
              <div class="col text-end" v-if="gameEnded">
                <router-link to="/lobby" class="back">
                  Retour au salon
                </router-link>
              </div>
              <div class="col text-end" v-else>
                <span class="back btn-link" v-on:click="modalLeaveShow = !modalLeaveShow">
                  Abandonner
                </span>
              </div>
            </div>
            <div class="row" v-if="displayNextGame">
              <div class="col-12">
                <button v-on:click="playNextGame" class="btn btn-link btn-lg">
                  Jouer à la prochaine partie
                </button>
              </div>
            </div>
            <div class="d-none d-md-flex row align-items-center">
              <div class="col-3">
                <RoundTimer v-bind:endDate="endDateTime" v-if="!gameEnded"></RoundTimer>
              </div>
              <div class="col-4" v-if="roundNumber > 0">
                Tour: {{roundNumber}}
              </div>
            </div>
            <div v-if="gameEnded && !premium">
              <adsense
                ad-style="display:block"
                ad-client="ca-pub-1546035667994677"
                ad-slot="7378148879"
                ad-format="auto"></adsense>
            </div>
            <div>
              <InfoBoard
                v-if="gameStarted"
                v-bind:boardValid="boardValid"
                v-bind:bestRoundPlayed="bestRoundPlayed"
              ></InfoBoard>
              <Deck v-bind:deck="deck"/>
              <div class="d-block">
                <GameChatStomp v-bind:gameId="activeGameId"></GameChatStomp>
              </div>
              <GameScores v-bind:scores="scores"
              v-bind:totalTop="totalTop"
              v-bind:lastTopWord="lastTopWord"
              v-bind:lastTopWordPoints="lastTopWordPoints"
              v-on:displayDefinition="displayDefinition"></GameScores>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bs-modal v-model="modalLeaveShow" ok-title="Abandonner" cancel-title="Annuler" v-on:ok="leave">
      <div class="d-block text-center">
      Abandonner la partie (et vos points) ?
      </div>
    </bs-modal>
    <div class="mt-auto">
      <div class="mt-4">
      <bottom-nav />
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import SquareLoader from '../SquareLoader.vue';
import BottomNav from '../BottomNav.vue';
import ClipLoader from '../ClipLoader.vue';
import Board from './Board.vue';
import GameDraw from './GameDraw.vue';
import LoggedUser from '../LoggedUser.vue';
import BoardUtils from './BoardUtils';
import BoardGameService from './board-game-service';
import RoundTimer from './RoundTimer.vue';
import SelectLetter from './SelectLetter.vue';
import InfoBoard from './InfoBoard.vue';
import GameTextInput from './GameTextInput.vue';
import GameScores from './GameScores.vue';
import GameChatStomp from './GameChatStomp.vue';
import FinalScores from './FinalScores.vue';
import Definition from './Definition.vue';
import Deck from './Deck.vue';
import adsense from '../VueAdsense.vue';
import BsModal from '../ui/BsModal.vue';


const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'Game',
  props: {
    activeGameId: {
      type: String,
      required: true,
    },
  },
  components: {
    SquareLoader,
    ClipLoader,
    Board,
    LoggedUser,
    BottomNav,
    RoundTimer,
    SelectLetter,
    InfoBoard,
    GameTextInput,
    GameScores,
    GameChatStomp,
    FinalScores,
    Definition,
    Deck,
    GameDraw,
    adsense,
    BsModal,
  },
  data() {
    return {
      loading: true,
      updating: false,
      username: iam.getConnectedUser().username,
      game: undefined,
      board: undefined,
      draw: undefined,
      scores: undefined,
      totalTop: 0,
      lastTopWordPoints: 0,
      lastTopWord: undefined,
      openedLetterSelection: false,
      boardValid: undefined,
      bestRoundPlayed: undefined,
      roundEndDate: undefined,
      gameStarted: false,
      gameEnded: false,
      squareClicked: undefined,
      timeout: undefined,
      dictionaryTimeout: undefined,
      roundNumber: undefined,
      modalLeaveShow: false,
      deck: undefined,
      horizontal: true,
      word: undefined,
      definition: undefined,
      premium: iam.isPremiumOrAdmin(),
      drawTop: false,
    };
  },
  computed: {
    endDateTime() {
      return this.roundEndDate
        ? this.roundEndDate.getTime()
        : new Date(this.game.startDate).getTime();
    },
    displayNextGame() {
      return this.game && this.game.creator === 'auto' && this.gameEnded;
    },
  },
  watch: {
    board() {
      this.submitWord();
    },
  },
  async created() {
    try {
      this.game = await this.findGameById(this.activeGameId);
    } catch {
      this.$router.push(`/ended-games/${this.activeGameId}`);
    }
    await this.loadRound();
    this.loading = false;
    this.loadDictionary();
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
    clearTimeout(this.dictionaryTimeout);
  },
  methods: {
    // Dictionnaire de la partie : le coup posé pendant son chargement est réévalué ensuite ;
    // en cas d'échec, nouvel essai 10 secondes plus tard.
    loadDictionary() {
      return BoardGameService.loadOds(this.game && this.game.dictionary)
        .then(() => this.submitWord())
        .catch(() => {
          this.dictionaryTimeout = setTimeout(() => this.loadDictionary(), 10000);
        });
    },
    async sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    async loadRound() {
      this.updating = true;
      clearTimeout(this.timeout);
      await this.sleep(200);
      if (this.$refs.gameTextInput) {
        this.$refs.gameTextInput.clear(true);
      }
      this.bestRoundPlayed = undefined;
      return this.findGameById(this.activeGameId).then((game) => {
        if (game.roundNumber > game.nbRounds) { // game ended
          this.gameEnded = true;
          this.timeout = setTimeout(() => this.$router.push(`/ended-games/${this.activeGameId}`), 120000);
        } else if (game.timeToNextRound) {
          this.timeout = setTimeout(() => this.loadRound(), game.timeToNextRound * 1000);
        }
        if (game.roundNumber > 0) {
          this.gameStarted = true;
        }
        if (game.rounds) {
          this.updateData(game);
        }
        this.updating = false;
      });
    },
    updateData(game) {
      this.roundEndDate = new Date(new Date().getTime() + (game.timeToNextRound * 1000));
      this.roundNumber = game.roundNumber;
      this.totalTop = game.rounds.slice(0, -1).reduce((acc, r) => acc + r.points, 0);
      const lastRound = game.roundNumber > 1 ? game.rounds.slice(-2, -1).pop() : undefined;
      this.lastTopWord = lastRound ? lastRound.word : undefined;
      this.lastTopWordPoints = lastRound ? lastRound.points : 0;
      this.scores = game.scores;
      this.board = BoardUtils.buildBoard(game.rounds.slice(0, -1));
      this.draw = BoardUtils.buildDraw(game.rounds.slice(-1)[0]);
      this.deck = BoardUtils.buildDeck(this.board, this.draw);
      if (this.gameEnded) {
        this.roundNumber = game.nbRounds;
        this.totalTop = game.rounds.reduce((acc, r) => acc + r.points, 0);
        const latestRound = game.rounds.slice(-1)[0];
        this.lastTopWord = latestRound.word;
        this.lastTopWordPoints = latestRound.points;
        this.board = BoardUtils.buildBoard(game.rounds);
        this.draw = [];
      }
      if (this.lastTopWord) {
        this.displayDefinition(this.lastTopWord.split(' ')[1]);
      }
    },
    convertDate(timestamp) {
      const h = padZero(new Date(Date.parse(timestamp)).getHours());
      const m = padZero(new Date(Date.parse(timestamp)).getMinutes());
      return `${h}h${m}`;
    },
    findGameById(activeGameId) {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/active-games/${activeGameId}`)
        .then(response => response.data);
    },
    keyDown(e) {
      const code = e.keyCode || e.which;
      if (code === 27) {
        this.clearBoard();
        if (this.$refs.gameTextInput) {
          this.$refs.gameTextInput.clear(true);
        }
      }
    },
    tileMoved(event) {
      if (this.roundNumber === event.roundNumber) {
        if (event.from === 'DrawSquare' && event.to.square != null) {
          const result = BoardGameService.moveDrawToBoard(
            this.draw,
            this.board,
            event.tile.drawIndex,
            event.to.square);
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from.square != null && event.to.square != null) {
          const result = BoardGameService.moveBoardToBoard(
            this.board,
            event.from.square,
            event.to.square,
          );
          this.board = result.board;
        } else if (event.from.square != null && event.to === 'DrawSquare') {
          const result = BoardGameService.moveBoardToDraw(
            this.board,
            this.draw,
            event.drawIndex,
            event.from.square);
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from === 'DrawSquare' && event.to === 'DrawSquare') {
          const result = BoardGameService.moveDrawToDraw(
            this.draw,
            event.tile,
            event.tile.drawIndex,
            event.drawIndex);
          this.draw.splice(0, this.draw.length, ...result.draw);
        } else if (event.from === 'GameTextInput') {
          const result = BoardGameService.moveWordToBoard(
            this.draw,
            this.board,
            event.word,
          );
          this.board = result.board;
          this.draw.splice(0, this.draw.length, ...result.draw);
        }
      }
      const elmnts = document.querySelectorAll('.move-on-drag-over');
      elmnts.forEach(elmnt => elmnt.classList.remove('move-on-drag-over'));
    },
    openLetterSelection(selectingTile) {
      this.openedLetterSelection = true;
      this.selectingTile = selectingTile;
    },
    closeLetterSelection(letter) {
      this.openedLetterSelection = false;
      this.selectingTile.value = letter;
      this.submitWord();
    },
    clearBoard() {
      const result = BoardGameService.clearBoard(this.draw, this.board);
      this.board = result.board;
      this.draw.splice(0, this.draw.length, ...result.draw);
      this.$refs.gameTextInput.clear(false);
    },
    shuffleDraw() {
      const shuffle = (x) => {
        const a = x;
        for (let i = a.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      };
      const s = shuffle(this.draw).map((t, index) => {
        const result = { ...t };
        result.drawIndex = index;
        return result;
      });
      this.draw.splice(0, this.draw.length, ...s);
    },
    clickSquare(square) {
      this.squareClicked = {
        row: square.row,
        column: square.column,
      };
    },
    submitWord() {
      this.boardValid = BoardGameService.isBoardValid(this.board);
      if (this.boardValid.valid) {
        const wordResult = this.boardValid.result;
        const currentRoundNumber = this.roundNumber;
        if (wordResult.valid &&
          (!this.bestRoundPlayed || wordResult.total > this.bestRoundPlayed.total)) {
          this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/active-scores`, {
            activeGameId: this.activeGameId,
            reference: wordResult.words[0].reference,
          }).then(() => {
            if (currentRoundNumber === this.roundNumber) {
              this.bestRoundPlayed = JSON.parse(JSON.stringify(wordResult));
            }
          });
        }
      }
    },
    setHorizontal(event) {
      this.horizontal = event;
    },
    lobby() {
      this.$router.push('/lobby');
    },
    leave() {
      const gamePlayerId = sessionStorage.getItem(`${this.game.id}`);
      if (!gamePlayerId) {
        this.$router.push('/lobby');
        return;
      }
      this.$http.delete(`${import.meta.env.VITE_LCT_API_URL}/game-players/${gamePlayerId}`)
        .then(() => {
          sessionStorage.removeItem(`${this.game.id}`);
          this.$router.push('/lobby');
        });
    },
    displayDefinition(word) {
      const w = word.replace(/[()]/g, '').toUpperCase();
      this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/definitions/${w}`)
        .then((response) => {
          const def = response.data.result;
          this.definition = def ? def.split(';') : undefined;
          this.word = w;
        });
    },
    playNextGame() {
      this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/lobby`)
        .then((lobbyResponse) => {
          const data = lobbyResponse.data;
          const game = data.games
            .find(g => g.creator === 'auto' &&
              Number(g.roundTime) === Number(this.game.roundTime) &&
              new Date(g.startDate).getTime() > new Date(this.game.endDate).getTime());
          if (game) {
            this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/game-players`, {
              username: iam.getConnectedUser().username,
              picture: iam.getConnectedUser().picture,
              activeGameId: game.id,
            }).then((response) => {
              sessionStorage.setItem(`${game.id}`, `${response.data.id}`);
              this.$router.push(`/games/${game.id}`);
            });
          }
        });
    },
  },
};
</script>

<style scoped>
div.loader {
  min-height: 100vh;
}

div.container:focus{
  outline: none;
}

.updating{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.back{
  color: #CE0F69;
  cursor: pointer;
  padding-left: 0;
}
img.icon {
  width: 16px;
  cursor: pointer;
}

.btn-link{
  color: #CE0F69;
}
</style>
